import { TicketStatus, type TicketStatus as TicketStatusType } from "./config";
import type { TicketListParams } from "@/services/supportTicketService";

export type TicketListView = "ongoing" | "all";

export function parseTicketListSearchParams(searchParams: URLSearchParams): {
  statusFilter: TicketStatusType | null;
  view: TicketListView | null;
} {
  const statusParam = searchParams.get("status");
  const viewParam = searchParams.get("view");

  const statusFilter =
    statusParam && Object.values(TicketStatus).includes(statusParam as TicketStatusType)
      ? (statusParam as TicketStatusType)
      : null;

  const view: TicketListView | null =
    viewParam === "all" || viewParam === "ongoing" ? viewParam : null;

  return { statusFilter, view };
}

export function normalizeStatusFilter(
  status: TicketStatusType | null,
): TicketStatusType | null {
  if (status === TicketStatus.WAITING_RESPONSE) {
    return TicketStatus.IN_PROGRESS;
  }
  return status;
}

/** Default list is ongoing (excludes resolved and closed). */
export function buildTicketListApiParams(
  statusFilter: TicketStatusType | null,
  view: TicketListView | null,
  extra?: Omit<TicketListParams, "status" | "ongoing_only">,
): TicketListParams {
  const ongoingOnly = !statusFilter && view !== "all";
  const status = normalizeStatusFilter(statusFilter);

  return {
    ...extra,
    status: status ?? undefined,
    ongoing_only: ongoingOnly ? true : undefined,
  };
}

export function getSelectedListView(
  statusFilter: TicketStatusType | null,
  view: TicketListView | null,
): TicketListView | null {
  if (normalizeStatusFilter(statusFilter)) return null;
  return view === "all" ? "all" : "ongoing";
}

export function isInProgressStatusFilter(status: TicketStatusType | null): boolean {
  return (
    status === TicketStatus.IN_PROGRESS ||
    status === TicketStatus.WAITING_RESPONSE
  );
}
